import { FiAlertTriangle, FiBox, FiFileText, FiMap, FiNavigation, FiRadio, FiSettings } from 'react-icons/fi';
import type { IconType } from 'react-icons';
import { cn } from '../lib/cn';

export type Tab = 'navigation' | 'occurrences' | 'rompimentos' | 'reports' | 'stock' | 'routes' | 'settings';

const TAB_META: Record<Tab, { label: string; Icon: IconType }> = {
  navigation: { label: 'Navegação', Icon: FiMap },
  occurrences: { label: 'Ocorrências', Icon: FiAlertTriangle },
  rompimentos: { label: 'Rompimentos', Icon: FiRadio },
  reports: { label: 'Relatórios', Icon: FiFileText },
  stock: { label: 'Estoque', Icon: FiBox },
  routes: { label: 'Rotas', Icon: FiNavigation },
  settings: { label: 'Configurações', Icon: FiSettings }
};

interface NavbarProps {
  tabs: Tab[];
  active: Tab;
  onChange: (tab: Tab) => void;
}

export default function Navbar({ tabs, active, onChange }: NavbarProps) {
  return (
    <nav className="flex gap-1 border-b border-slate-200 bg-white px-2 sm:px-4">
      {tabs.map((t) => {
        const { label, Icon } = TAB_META[t];
        const isActive = active === t;
        return (
          <button
            key={t}
            onClick={() => onChange(t)}
            className={cn(
              'flex items-center gap-2 border-b-2 px-3 py-3 text-sm font-semibold transition-colors sm:px-4',
              isActive
                ? 'border-blue-600 text-blue-700'
                : 'border-transparent text-slate-500 hover:border-slate-200 hover:text-slate-700'
            )}
          >
            <Icon size={18} />
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
